import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(timezone)
dayjs.extend(utc)

// https://docs.google.com/presentation/d/1bf8vhl_zPxH5q9i2iaDOG9Jh1HjrNdshufVctB3C_4M/edit#slide=id.g33833876c15_0_0
// https://github.com/weathernews/with_cloth
/**
 *
 * @param {object} srf
 * @param {object} mrf
 * @param {string} timezone
 * @returns {object} 服装気温を追加したmrf
 */
export const calcClothTemp = (srf, mrf, timezone) => {
  const now = dayjs().tz(timezone).startOf('day')

  const calculateNighttimeTemp = (targetDate) => {
    const daytimeHours = [7, 8, 9, 18, 19, 20]
    const daytimeTemps = srf.filter((srfItem) => daytimeHours.includes(srfItem.hour) && srfItem.date === targetDate && srfItem.feeltemp != null)
    return daytimeTemps.length > 0 ? daytimeTemps.reduce((sum, temp) => sum + temp.feeltemp, 0) / daytimeTemps.length : null
  }

  const calculateDaytimeTemp = (targetDate) => {
    const nighttimeHours = [10, 11, 12, 13, 14, 15, 16, 17]
    const nighttimeTemps = srf.filter((srfItem) => nighttimeHours.includes(srfItem.hour) && srfItem.date === targetDate && srfItem.feeltemp != null)
    return nighttimeTemps.length > 0 ? nighttimeTemps.reduce((sum, temp) => sum + temp.feeltemp, 0) / nighttimeTemps.length : null
  }

  const calculateFutureDaytimeTemp = (maxTemp, minTemp) => {
    return (maxTemp - minTemp) * 0.8 + minTemp
  }

  const calculateFutureNighttimeTemp = (maxTemp, minTemp) => {
    return (maxTemp - minTemp) * 0.3 + minTemp
  }

  const retMrf = []

  mrf.forEach((mrfItem) => {
    const targetDate = dayjs.unix(mrfItem.utm).tz(timezone)

    // FTレンジが足りないことがあるので、NIWA-san ロジックから変更
    // https://weathernews.slack.com/archives/CFV628LBC/p1741161980627889?thread_ts=1737013264.300829&cid=CFV628LBC
    if (dayjs.tz(targetDate, timezone).isBefore(now.add(3, 'day'))) {
      const date = targetDate.format('YYYYMMDD')
      mrfItem.daytimeClothRank = calcClothRank(calculateDaytimeTemp(date)) != null ? calcClothRank(calculateDaytimeTemp(date)) : calcClothRank(calculateFutureDaytimeTemp(mrfItem.maxt, mrfItem.mint))
      mrfItem.nighttimeClothRank = calcClothRank(calculateNighttimeTemp(date)) != null ? calcClothRank(calculateNighttimeTemp(date)) : calcClothRank(calculateFutureNighttimeTemp(mrfItem.maxt, mrfItem.mint))
    } else {
      const maxTemp = mrfItem.maxt
      const minTemp = mrfItem.mint
      mrfItem.daytimeClothRank = calcClothRank(calculateFutureDaytimeTemp(maxTemp, minTemp))
      mrfItem.nighttimeClothRank = calcClothRank(calculateFutureNighttimeTemp(maxTemp, minTemp))
    }
    retMrf.push(mrfItem)
  })

  return retMrf
}

// eslint-disable-next-line complexity
export const calcClothRank = (temp) => {
  // https://github.com/weathernews/with_cloth/blob/main/bin/calc_cloth_ft.py#L95-L109
  // ただし、上記で出力するインデックスと、画像として持ってるインデックスの順番がずれているので、後者に合わせる形で吸収する
  if (temp == null) return null
  if (temp >= 30) return 11
  if (temp >= 28) return 10
  if (temp >= 25) return 9
  if (temp >= 20) return 8
  if (temp >= 15) return 7
  if (temp >= 13) return 6
  if (temp >= 10) return 5
  if (temp >= 7) return 4
  if (temp >= 4) return 3
  if (temp >= 1) return 2
  return 1
}

// eslint-disable-next-line complexity
export const getClothIconTelop = (clothRank) => {
  if (clothRank == null) return null
  if (clothRank === 11) return 'ノースリーブ'
  if (clothRank === 10) return 'Tシャツ1枚'
  if (clothRank === 9) return '半袖シャツ1枚'
  if (clothRank === 8) return '長袖シャツ1枚'
  if (clothRank === 7) return 'カーディガン'
  if (clothRank === 6) return '薄手セーター'
  if (clothRank === 5) return '厚手セーター（厚手スウェット）'
  if (clothRank === 4) return '春秋コート'
  if (clothRank === 3) return '冬物コート'
  if (clothRank === 2) return 'ダウンコート'
  if (clothRank === 1) return 'ダウンコート＋防寒アイテム'
  return null
}

// https://docs.google.com/spreadsheets/d/1VKr6u6go4eoDFDiaJZQ4mnI_OhUo5iAXL546lLuXvdQ/edit?gid=1426780508#gid=1426780508
export const getGraphComment = (pointInfo, compareInfo, pointName, compareName) => {
  // 気温: 最高
  const validMaxtPoints = pointInfo.filter((point) => point.maxt != null)
  const validMaxtCompares = compareInfo.filter((compare) => compare.maxt != null)
  const pointMaxtMedian = validMaxtPoints.length > 0 ? median(validMaxtPoints.map((point) => point.maxt)) : null
  const compareMaxtMedian = validMaxtCompares.length > 0 ? median(validMaxtCompares.map((compare) => compare.maxt)) : null

  const pointMaxtSum = validMaxtPoints.reduce((sum, point) => sum + point.maxt, 0)
  const pointMaxtAvg = validMaxtPoints.length > 0 ? pointMaxtSum / pointInfo.length : null
  const compareMaxtSum = validMaxtCompares.reduce((sum, compare) => sum + compare.maxt, 0)
  const compareMaxtAvg = validMaxtCompares.length > 0 ? compareMaxtSum / compareInfo.length : null

  // 気温: 最低
  const validMintPoints = pointInfo.filter((point) => point.mint != null)
  // const validMintCompares = compareInfo.filter((compare) => compare.mint != null)

  // 服装気温
  const validDaytimeRanks = pointInfo.filter((point) => point.daytimeClothRank != null)
  const validNighttimeRanks = pointInfo.filter((point) => point.nighttimeClothRank != null)
  const pointDaytimeMedian = validDaytimeRanks.length > 0 ? median(validDaytimeRanks.map((point) => point.daytimeClothRank)) : null
  const roundedDaytimeMedian = pointDaytimeMedian != null ? Math.round(pointDaytimeMedian) : null
  const pointNighttimeMedia = validNighttimeRanks.length > 0 ? median(validNighttimeRanks.map((point) => point.nighttimeClothRank)) : null
  const roundedNighttimeMedian = pointNighttimeMedia != null ? Math.round(pointNighttimeMedia) : null

  // eslint-disable-next-line complexity
  const getMaxtDiffComment = () => {
    let diffComment
    if (pointMaxtMedian == null || compareMaxtMedian == null) return ''
    const maxtDiffs = pointInfo.map((point, index) => {
      const compareMaxt = compareInfo[index] && validMaxtCompares[index]?.maxt != null ? validMaxtCompares[index].maxt : null
      return compareMaxt != null ? point.maxt - compareMaxt : null
    }).filter((diff) => diff != null)

    if (maxtDiffs.length === 0) return ''

    if (Math.max(...maxtDiffs) >= 5 && Math.min(...maxtDiffs) <= -5) {
      return `この先1週間の${pointName}は、${compareName}との気温差が大きくなります。`
    }

    if (pointMaxtAvg == null || compareMaxtAvg == null) return ''

    if (pointMaxtAvg >= compareMaxtAvg + 20) {
      diffComment = 'より極端に高くなります。'
    } else if (pointMaxtAvg >= compareMaxtAvg + 12) {
      diffComment = 'よりかなり高くなります。'
    } else if (pointMaxtAvg >= compareMaxtAvg + 3) {
      diffComment = 'より高くなります。'
    } else if (pointMaxtAvg > compareMaxtAvg - 3) {
      diffComment = 'と同じくらいです。'

      const maxAbsMaxtDiff = Math.max(...maxtDiffs.map(Math.abs))
      const arrayTargetMatxDiff = maxtDiffs.filter((diff) => Math.abs(diff) === maxAbsMaxtDiff)
      const uniqueTargetMatxDiff = [...new Set(arrayTargetMatxDiff)]
      const numMaxMaxtDiffCount = uniqueTargetMatxDiff.length
      if (numMaxMaxtDiffCount > 1) {
        diffComment += `ただ、${compareName}と比較して気温差が大きい日もあります。`
      } else {
        const maxMaxtDiff = maxtDiffs.find((diff) => Math.abs(diff) === maxAbsMaxtDiff)

        if (maxMaxtDiff >= 20) {
          diffComment += `ただ、${compareName}より極端に高くなる日もあります。`
        } else if (maxMaxtDiff >= 12) {
          diffComment += `ただ、${compareName}よりかなり高くなる日もあります。`
        } else if (maxMaxtDiff >= 3) {
          diffComment += `ただ、${compareName}より高くなる日もあります。`
        } else if (maxMaxtDiff > -3) {
          // この時は追加コメントなし
        } else if (maxMaxtDiff > -12) {
          diffComment += `ただ、${compareName}より低くなる日もあります。`
        } else if (maxMaxtDiff > -20) {
          diffComment += `ただ、${compareName}よりかなり低くなる日もあります。`
        } else {
          diffComment += `ただ、${compareName}より極端に低くなる日もあります。`
        }
      }
    } else if (pointMaxtAvg > compareMaxtAvg - 12) {
      diffComment = 'より低くなります。'
    } else if (pointMaxtAvg > compareMaxtAvg - 20) {
      diffComment = 'よりかなり低くなります。'
    } else {
      diffComment = 'より極端に低くなります。'
    }
    return `この先1週間の${pointName}の最高気温は${compareName}${diffComment}`
  }

  // eslint-disable-next-line complexity
  const getClothComment = () => {
    let res = ''
    if (pointDaytimeMedian == null) return res

    if (roundedDaytimeMedian === 11) {
      res += '昼間は、ノースリーブ1枚でも過ごせる暑さです。'
    } else if (roundedDaytimeMedian === 10) {
      res += '昼間は、Tシャツ1枚で過ごせる暑さです。'
    } else if (roundedDaytimeMedian === 9) {
      res += '昼間は、厚手の半袖Tシャツや襟付きの半袖シャツ1枚くらいがちょうどいい暑さです。'
    } else if (roundedDaytimeMedian === 8) {
      res += '昼間は、長袖シャツ1枚くらいで快適に過ごせそうです。'
    } else if (roundedDaytimeMedian === 7) {
      res += '昼間は、長袖Tシャツなどの上に、薄手の羽織るものがあると快適に過ごせそうです。'
    } else if (roundedDaytimeMedian === 6) {
      res += '昼間は、長袖Tシャツなどの上に薄手のセーター1枚重ねるくらいで快適に過ごせそうです。'
    } else if (roundedDaytimeMedian === 5) {
      res += '昼間は、長袖Tシャツなどの上に厚手のセーターやスウェットなど、熱を逃しにくいものを重ねた暖かな服装がちょうど良さそうです。'
    } else if (roundedDaytimeMedian === 4) {
      res += '昼間は、裏地がないような春秋向けのアウターやジャケットなどの上着があるとちょうど良く過ごせそうです。'
    } else if (roundedDaytimeMedian === 3) {
      res += '昼間は、裏地もあるしっかりとした冬物コートがあると暖かに過ごせそうです。風の冷たさが気になる方は、手袋や帽子など冬小物があると良さそうです。'
    } else if (roundedDaytimeMedian === 2) {
      res += '昼間は、ダウンコートなど風や冷気を通さず、保温効果が高いアウターが重宝する寒さです。冬物コートの場合は、マフラーなどで首元もしっかりと暖めておでかけください。'
    } else {
      res += '昼間は、ダウンコートなど風や冷気を通さず、保温効果が高いアウターが重宝する寒さです。手袋や帽子、カイロなども活用して最大限の防寒を。'
    }

    const pointDaytimeMin = Math.min(...validDaytimeRanks.map((point) => point.daytimeClothRank))

    if (pointDaytimeMin >= 9) {
      res += '冷房の効いた室内用にストールやカーディガンなどがあると重宝します。'
    } else if (roundedDaytimeMedian - pointDaytimeMin >= 2) {
      let tmpClothName
      if (pointDaytimeMin >= 7) {
        tmpClothName = pointDaytimeMin >= 8 ? '長袖シャツ' : '長袖シャツやカーディガン'
        res += `肌寒い日に備えて、${tmpClothName}など羽織れるものをご用意ください。`
      } else if (pointDaytimeMin >= 5) {
        tmpClothName = pointDaytimeMin >= 6 ? 'セーター' : 'セーターやスウェット'
        res += `冷え込む日に備えて、${tmpClothName}などをご用意ください。`
      } else if (pointDaytimeMin >= 2) {
        tmpClothName = pointDaytimeMin >= 4 ? '春秋コート' : pointDaytimeMin >= 3 ? '冬物コートやマフラーなどの防寒具' : 'ダウンコートやマフラーなどの防寒具'
        res += `冷え込む日は、${tmpClothName}が重宝します。`
      } else if (roundedDaytimeMedian - pointDaytimeMin >= 3) {
        res += '特に冷え込む日は、ダウンコートやマフラーなどの防寒具が重宝します。'
      }
    }

    return res
  }

  const getDayNightDiffComment = () => {
    if (pointDaytimeMedian == null || pointNighttimeMedia == null) {
      return ''
    } else if (Math.abs(roundedNighttimeMedian - roundedDaytimeMedian) >= 2) {
      return '朝晩と昼間では体感が大きく変わります。重ね着で調節できる服装がおすすめです。'
    } else if (roundedDaytimeMedian - roundedNighttimeMedian >= 1) {
      return '朝晩のほうが寒い日が多くなります。重ね着で調節できる服装がおすすめです。'
    } else if (roundedNighttimeMedian - roundedDaytimeMedian >= 1) {
      return '朝晩よりも昼間のほうが寒くなる日が多くなります。出かける時の服装に注意してください。'
    } else {
      return '出かける時の服装で1日ちょうど良く過ごせる日が多くなります。'
    }
  }

  const getDailyDiffComment = () => {
    if (validMaxtPoints.length < 1 || validMintPoints.length < 1) return ''

    const maxMaxt = Math.max(...validMaxtPoints.map((point) => point.maxt))
    const minMaxt = Math.min(...validMaxtPoints.map((point) => point.maxt))

    const maxMint = Math.max(...validMintPoints.map((point) => point.mint))
    const minMint = Math.min(...validMintPoints.map((point) => point.mint))
    if (maxMaxt - minMaxt >= 10 || maxMint - minMint >= 10) {
      return '日毎の気温差が大きくなるため、日々の天気予報を確認して体調を崩さないようお気をつけください。'
    }
    return ''
  }

  return getMaxtDiffComment() + getClothComment() + getDayNightDiffComment() + getDailyDiffComment()
}

const median = (arr) => {
  const sortedArr = arr.slice().sort((a, b) => a - b)
  const mid = Math.floor(sortedArr.length / 2)
  return sortedArr.length % 2 !== 0 ? sortedArr[mid] : (sortedArr[mid - 1] + sortedArr[mid]) / 2
}
